import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { api } from './api/api';
import bookmarksReducer from './plain/bookmarks/reducer';
import coverbgReducer from './plain/coverbg/reducer';
import geeksJokeReducer from './plain/geeksJoke/reducer';
import jokeReducer from './plain/joke/reducer';
import authSlice from './slices/authSlice';
import draftSlice from './slices/draftSlice';
import replyContextSlice from './slices/replyContextSlice';
import uiContextSlice from './slices/uiContextSlice';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authSlice,
    replyContext: replyContextSlice,
    draft: draftSlice,
    loadingBar: loadingBarReducer,
    coverbg: coverbgReducer,
    joke: jokeReducer,
    geeksJoke: geeksJokeReducer,
    bookmarks: bookmarksReducer,
    uiContext: uiContextSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      auth: authSlice,
      replyContext: replyContextSlice,
      draft: draftSlice,
      loadingBar: loadingBarReducer,
      coverbg: coverbgReducer,
      joke: jokeReducer,
      geeksJoke: geeksJokeReducer,
      bookmarks: bookmarksReducer,
      uiContext: uiContextSlice,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
  });
};

setupListeners(store.dispatch);
